import dynamic from "next/dynamic";
import React from "react";
import ToResolveClassNameError from "../../components/hoc/ToResolveClassNameError";
import ExpiredJobWrapper from "../../components/jobs/ExpiredJobWrapper/ExpiredJobWrapper";
import SingleJobWrapper from "../../components/jobs/SingleJobWrapper/SingleJobWrapper";
import SharedJobHeader from "../../components/shared/SharedHeader/SharedJobHeader/SharedJobHeader";
import SharedNavbar2 from "../../components/shared/SharedNavbar/Navbar/Navbar";
import {
  getJobWithoutRedux,
  getPostApplyRecommendedJobsWithoutRedux,
} from "../../redux/actions/job_action";

const SharedChat = dynamic(() =>
  import("../../components/shared/SharedChat/SharedChat")
);

const SharedFooter = dynamic(() =>
  import("../../components/shared/SharedFooter/SharedFooter")
);

const Toolbar = dynamic(() => import("@mui/material/Toolbar"));

function JobProfile(props) {
  return (
    <div aria-label="job-detail-body">
      <SharedJobHeader job={props.job} />
      <ToResolveClassNameError>
        <SharedNavbar2
          page="single-job-page"
          breadcrumbItems={[
            { label: "Jobs", href: "/jobs" },
            { label: props.job?.title },
          ]}
        />
      </ToResolveClassNameError>
      <Toolbar
        sx={{
          "@media(min-width: 1280px)": {
            // minHeight: "64px",
            minHeight: "104px !important",
          },
          "@media(max-width: 1279px)": {
            // minHeight: "52px",
            minHeight: "92px !important",
          },
          "@media(max-width: 639px)": {
            // minHeight: "60px",
            minHeight: "100px !important",
          },
        }}
      />
      {props.jobExpired ? (
        <ExpiredJobWrapper job={props.job} similarJobs={props.similarJobs} />
      ) : (
        <SingleJobWrapper job_slug={props.id} serverJob={props.job} />
      )}
      <ToResolveClassNameError>
        <SharedChat tag={"single-job-page"} />
        <SharedFooter />
      </ToResolveClassNameError>
    </div>
  );
}

export async function getStaticPaths() {
  let paths = [];

  return {
    paths: paths,
    fallback: "blocking",
  };
}

export async function getStaticProps({ params }) {
  let job = null;
  let similarJobs = null;

  const param = {
    jobId: params.id,
    canCancel: false,
  };

  if (params.id) {
    try {
      job = await getJobWithoutRedux(param);

      if (job?.jobNotFound) {
        return {
          notFound: true,
          revalidate: 60 * 5,
        };
      }

      if (job?.expired) {
        const jobParams = {
          globalId: job?.globalId,
          first: 9,
        };

        similarJobs = await getPostApplyRecommendedJobsWithoutRedux(jobParams);

        return {
          props: {
            id: params.id,
            job: job,
            jobExpired: job?.expired,
            similarJobs: similarJobs,
          },
          revalidate: 60 * 60 * 1,
        };
      }
    } catch (error) {
      return {
        notFound: true,
        revalidate: 60 * 5,
      };
    }
  } else {
    return {
      notFound: true,
      revalidate: 60 * 5,
    };
  }

  return {
    props: {
      id: params.id,
      job: job,
    },
    revalidate: 60 * 5,
  };
}

export default JobProfile;
